import {
  Route, Switch, useRouteMatch, Redirect,
} from 'react-router-dom';
import ActivityManagement from '@src/modules/performance/views/reports/activity-management/ActivityManagement';
import ServicePerformance from '@src/modules/performance/views/reports/ServicePerformance';
import CoInvestorAssurance from '@src/modules/performance/views/reports/CoInvestorAssurance';
import TransportProgrammeDelivery from '@src/modules/performance/views/reports/TransportProgrammeDelivery';
import RoadMaintenanceDelivery from '@src/modules/performance/views/reports/RoadMaintenanceDelivery';
import RoadCondition from '@src/modules/performance/views/reports/RoadCondition';
import RoadSafety from '@src/modules/performance/views/reports/RoadSafety';
import NetworkAvailability from '@src/modules/performance/views/reports/NetworkAvailability';
import TerritorialActivity from '@src/modules/performance/views/reports/TerritorialActivity';
import RoadNetworkUse from '@src/modules/performance/views/reports/RoadNetworkUse';
import PublicTransport from '@src/modules/performance/views/reports/PublicTransport';
import { AuthenticateUser } from '@src/routes/auth';
import LevelsOfService from '../views/levels-of-service';
import AnnualReports from '../views/annualreports';
import NetworkPhysicalCharacteristics from '../views/reports/NetworkPhysicalCharacteristics';
import NetworkCharacteristics from '../views/network-characteristics/NetworkCharacteristics';
import ActivityManagementPlans from '../views/activity-management-plans';
import CrashMapPoc from '../views/crash-map-poc';
import PlanningQualityPillars from '../views/reports/activity-management/PlanningQualityPillars';
import MaintenanceOperations from '../views/maintenance-operations/MaintenanceOperations';
import TemporaryTrafficManagement from '../views/quarterly-reporting/temporary-traffic-management';
import QuarterlyReportingAdmin from '../views/quarterly-reporting/admin';
import TemporaryTrafficManagementReport from '../views/reports/TemporaryTrafficManagement';
import Dashboard from '../views/dashboard';
import StateHighwaysPotholeRepairs from '../views/reports/StateHighwaysPotholeRepairs';
import E3 from '../views/reports/E3';
import Potholes from '../views/quarterly-reporting/potholes';
import CustomReports from '../views/custom-reports';
import FullReport from '../views/reports/FullReport';
import DataQuality from '../views/reports/DataQuality';

export default function Routes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      {/* Redirect reports to new url */}
      <Route
        path={`${path}/reports/:report`}
        render={({ match }) => (
          <Redirect to={`${path}/dashboard/${match.params.report}`} />
        )}
      />
      <Route path={`${path}/annual-reports`} component={AnnualReports} />
      <Route path={`${path}/dashboard/delivery-performance`} component={RoadMaintenanceDelivery} />
      <Route path={`${path}/dashboard/amenity-and-condition`} component={RoadCondition} />
      <Route path={`${path}/dashboard/activity-management/planning-quality-pillars`} component={PlanningQualityPillars} exact />
      <Route path={`${path}/dashboard/activity-management`} component={ActivityManagement} />
      <Route path={`${path}/dashboard/coinvestor-assurance`} component={CoInvestorAssurance} />
      <Route path={`${path}/dashboard/delivery`} component={TransportProgrammeDelivery} />
      <Route path={`${path}/dashboard/network-availability`} component={NetworkAvailability} />
      <Route path={`${path}/dashboard/network-physical-characteristics`} component={NetworkPhysicalCharacteristics} />
      <Route path={`${path}/dashboard/public-transport`} component={PublicTransport} />
      <Route path={`${path}/dashboard/service-performance`} component={ServicePerformance} />
      <Route path={`${path}/dashboard/road-network-use`} component={RoadNetworkUse} />
      <Route path={`${path}/dashboard/territorial-activity`} component={TerritorialActivity} />
      <Route path={`${path}/dashboard/safety`} component={RoadSafety} />
      <Route path={`${path}/dashboard/state-highways-pothole-repairs`} component={StateHighwaysPotholeRepairs} />
      <Route path={`${path}/dashboard/value-for-money`} component={E3} />
      <Route path={`${path}/dashboard/temporary-traffic-management`} component={TemporaryTrafficManagementReport} />
      <Route path={`${path}/dashboard/data-quality`} component={DataQuality} />
      <Route path={`${path}/custom-reports`} component={CustomReports} />
      <Route path={`${path}/dashboard/full-report`} component={FullReport} />
      <Route path={`${path}/asset-condition`} component={LevelsOfService} />
      <Route path={`${path}/maintenance-operations`} component={MaintenanceOperations} exact />
      <Route path={`${path}/networkchar`} component={NetworkCharacteristics} />
      <Route path={`${path}/network-characteristics`} component={NetworkCharacteristics} />
      <Route path={`${path}/dashboard/network-physical-characteristics`} component={NetworkPhysicalCharacteristics} />
      <Route path={`${path}/activity-management-plans`} component={ActivityManagementPlans} />
      <Route path={`${path}/crash-map`} component={CrashMapPoc} />
      <Route path={`${path}/dashboard`} component={Dashboard} />
      <AuthenticateUser redirectToLoginPage>
        <Route path={`${path}/quarterly-reporting/temporary-traffic-management`} component={TemporaryTrafficManagement} />
        <Route path={`${path}/quarterly-reporting/potholes`} component={Potholes} />
        <Route path={`${path}/quarterly-reporting/admin-report`} component={QuarterlyReportingAdmin} />
        <Route
          exact
          path={`${path}/quarterly-reporting`}
          render={({ location }) => (
            <Redirect to={{
              pathname: `${path}/quarterly-reporting/temporary-traffic-management`,
              search: location.search,
            }}
            />
          )}
        />
      </AuthenticateUser>
    </Switch>
  );
}
